import React, { useEffect, useState } from 'react';

import { PERMISSION_DENIED_SEARCH } from 'utils/return-url';
import { Redirect } from 'react-router-dom';
import ScreenLoading from 'views/ui/screen-loading';
import { logoutUser } from 'modules/auth/actions';
import { useDispatch } from 'react-redux';

// Terminal for a signed-in user who asked for a page their account is not allowed.
// The session ends and they land on the login screen, which explains why — the same
// answer the login endpoint gives an account this app refuses.
//
// The sign-out is dispatched *before* the redirect renders, not alongside it: the
// redirect unmounts this component, and an effect racing that would be a coin flip on
// whether the session was ever cleared.
//
// Plain `logoutUser()` rather than the `manual` variant on purpose — the manual flag
// makes logoutUserSaga navigate to a clean login URL itself, which would race this
// redirect and drop the reason from the query string.
const PermissionDenied = () => {
  const dispatch = useDispatch();
  const [signedOut, setSignedOut] = useState(false);

  useEffect(() => {
    dispatch(logoutUser());
    setSignedOut(true);
  }, [dispatch]);

  if (!signedOut) return <ScreenLoading />;

  return <Redirect to={{ pathname: '/', search: PERMISSION_DENIED_SEARCH }} />;
};

export default PermissionDenied;
